<div class="margin-top-md">

	<div *ngIf="results.length > 0" class="margin-top-md">
		<mat-table [dataSource]="tableDataSources[0]" class="table-responsive mat-elevation-z1" matSort>
			<form [formGroup]="editingForm">
				<ng-container matColumnDef="EDIT">
					<mat-header-cell *matHeaderCellDef> </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div *ngIf="element.ID !== editingId">
							<button mat-icon-button color="primary" (click)="editWorkflowStateType(element)"
								matTooltip="Edit">
								<mat-icon>edit</mat-icon>
							</button>
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'delete'" [color]="'warn'"
								[popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'"
								[popoverConfirmColor]="'warn'" [tooltip]="'Delete'"
								(onConfirm)="deleteWorkflowStateType(element)" *ngIf="hasPermission">
							</confirm-popover>
						</div>
						<div *ngIf="element.ID === editingId">
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'check'" [color]="'primary'"
								[popoverMsg]="'Update WorkflowStateType'" [popoverConfirmText]="'Confirm'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Update'"
								(onConfirm)="confirmEditWorkflowStateType()" [disabled]="!editingForm.valid">
							</confirm-popover>

							<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
								[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'"
								(onConfirm)="cancelEditWorkflowStateType()">
							</confirm-popover>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div *ngIf="element.ID !== editingId">
							{{element.NAME}}
						</div>
						<div *ngIf="element.ID === editingId" class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Name
								</mat-label>
								<input matInput type="string" placeholder="Workflow State Name"
									formControlName="name" />
							</mat-form-field>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="DESCRIPTION">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Description </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div *ngIf="element.ID !== editingId">
							{{element.DESCRIPTION}}
						</div>
						<div *ngIf="element.ID === editingId" class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Description
								</mat-label>
								<input matInput type="string" placeholder="Workflow State Description"
									formControlName="description" />
							</mat-form-field>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="ACTION">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div *ngIf="element.ID !== editingId">
							{{element.ACTION}}
						</div>
						<div *ngIf="element.ID === editingId" class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Action
								</mat-label>
								<input matInput type="string" placeholder="Workflow State Action"
									formControlName="action" />
							</mat-form-field>
						</div>
					</mat-cell>
				</ng-container>
			</form>

			<ng-container matColumnDef="ADD" disabled>
				<mat-header-cell *matHeaderCellDef>
					<div *ngIf="!adding">
						<button mat-raised-button color="primary" (click)="addWorkflowStateType()"
							*ngIf="hasPermission">New
							Workflow State</button>
					</div>
				</mat-header-cell>
			</ng-container>

			<form [formGroup]="addingForm">
				<ng-container matColumnDef="ADD_EDIT" disabled>
					<mat-header-cell *matHeaderCellDef>
						<div *ngIf="adding">
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'add'" [color]="'primary'"
								[popoverMsg]="'Add new WorkflowStateType'" [popoverConfirmText]="'Add'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Add'"
								(onConfirm)="confirmAddWorkflowStateType()" [disabled]="!addingForm.valid">
							</confirm-popover>
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
								[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'"
								(onConfirm)="cancelAddWorkflowStateType()">
							</confirm-popover>
						</div>
					</mat-header-cell>
				</ng-container>

				<ng-container matColumnDef="ADD_NAME">
					<mat-header-cell *matHeaderCellDef>
						<div class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Name
								</mat-label>
								<input matInput type="string" placeholder="Workflow State Name"
									formControlName="name" />
							</mat-form-field>
						</div>
					</mat-header-cell>
				</ng-container>

				<ng-container matColumnDef="ADD_DESCRIPTION">
					<mat-header-cell *matHeaderCellDef>
						<div class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Description
								</mat-label>
								<input matInput type="string" placeholder="Workflow State Description"
									formControlName="description" />
							</mat-form-field>
						</div>
					</mat-header-cell>
				</ng-container>

				<ng-container matColumnDef="ADD_ACTION">
					<mat-header-cell *matHeaderCellDef>
						<div class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Action
								</mat-label>
								<input matInput type="string" placeholder="Workflow State Action"
									formControlName="action" />
							</mat-form-field>
						</div>
					</mat-header-cell>
				</ng-container>
			</form>

			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matHeaderRowDef="newDisplayedColumns" [hidden]="!hasPermission"></mat-row>
			<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
		</mat-table>

	</div>
</div>